export const MONITORING_TYPE = {
  'MONITORING-INITIAL': 'MONITORING-INITIAL',
  MAP: 'MAP',
  MAPV2: 'MAPV2',
  PERFORMANCE: 'PERFORMANCE',
  'LAST-SHIFT': 'LAST-SHIFT',
  CHARGING: 'CHARGING',
  'TRANSFER-B57-DISCHARGING': 'TRANSFER-B57-DISCHARGING',
  DISCHARGING: 'DISCHARGING',
  'TRANSFER-B57': 'TRANSFER-B57',
  IDLE: 'IDLE',
  'EFFECTIVE-TIME-DRIVER': 'EFFECTIVE-TIME-DRIVER',
  PUNCTURES: 'PUNCTURES',
  COMPOSTING: 'COMPOSTING',
  ROLLER: 'ROLLER',
  CAN: 'CAN',
  GEOFENCEG1: 'GEOFENCEG1',
  LOWVELOCITY: 'LOWVELOCITY',
};

export const SECURITY_TYPE = {
  'SECURITY-INITIAL': 'SECURITY-INITIAL',
  'TRUCK-APPROACH': 'TRUCK-APPROACH',
  'VELOCITY-VIOLATION': 'VELOCITY-VIOLATION',
  'BRAKE-RETARDER': 'BRAKE-RETARDER',
  'VELOCITY-HISTORIC': 'VELOCITY-HISTORIC',
  CAN: 'CAN',
  FATIGUE: 'FATIGUE',
  'SENSORS-COUNT': 'SENSORS-COUNT',
  TRAIN: 'TRAIN',
  CAMERA: 'CAMERA',
};

export const MAINTENANCE_TYPE = {
  'MAINTENANCE-INITIAL': 'MAINTENANCE-INITIAL',
  PREVENTIVE: 'PREVENTIVE',
  PREDICTIVE: 'PREDICTIVE',
  ONGOING: 'ONGOING',
  COMPLETED: 'COMPLETED',
  PERMANENCE: 'PERMANENCE',
};

export const RECORDS_TYPE = {
  'RECORDS-INITIAL': 'RECORDS-INITIAL',
  DRIVER: 'DRIVER',
  MACHINES: 'MACHINES',
  // GEOFENCES: 'GEOFENCES',
  ROUTES: 'ROUTES',
  GATES: 'GATES',
};

export const DATABASE_TYPE = {
  'DATABASE-INITIAL': 'DATABASE-INITIAL',
  GPS: 'GPS',
  CANBUS: 'CANBUS',
  PRODUCTIVITY: 'PRODUCTIVITY',
  HOURMETER: 'HOURMETER',
};

export const USERS_TYPE = {
  'USERS-INITIAL': 'USERS-INITIAL',
  RECOMENDATIONS: 'RECOMENDATIONS',
};

export const ORDERS_TYPE = {
  ORDER: 'ORDER',
};

export const REPORTS_TYPE = {
  REPORT: 'REPORT',
};

export const PRODUCTIVITY_TYPE = {
  KPITREE: 'KPITREE',
};

export const CAN_TYPE = {
  DASHBOARD: 'DASHBOARD',
};

export const HUELLA_TYPE = {
  DASHBOARD: 'DASHBOARD',
  RALENTI: 'RALENTI',
};

export const CYCLES_TYPE = {
  CYCLES: 'CYCLES',
};

export const TIMES_TYPE = {
  TIMES: 'TIMES',
};

// Path names with prettier names for the 'Last Visited' component
export const PATH_NAMES = {
  '/': 'Inicio',
  '/dashboard': 'Inicio',
  '/login': 'Login',
  '/documentation': 'Documentación',
  '/documentation/general/create-geofence': 'Como crear una geocerca',
  '/documentation/security/collect-team-data':
    'Como recolectar datos de un equipo',
  '/documentation/security/update-license': 'Como actualizar una licencia',
  '/documentation/maintenance/enter-truck':
    'Como ingresar un camion a mantenimiento',
  '/documentation/maintenance/complete-form': 'Como completar un mantenimiento',
  '/maintenance/maintenance-initial': 'Mantenimientos',
  '/maintenance/preventive': 'Gestión de Mantenimiento Preventivo',
  '/maintenance/predictive': 'Gestión de Mantenimiento Predictivo',
  '/maintenance/ongoing': 'Mantenimientos en Curso',
  '/maintenance/completed': 'Mantenimientos Completados',
  '/maintenance/permanence': 'Registro de permanencia en talleres',
  '/monitoring/monitoring-initial': 'Mapa y Monitoreo',
  '/monitoring/map': 'Mapa de Flota',
  '/monitoring/mapv2': 'Mapa de Flota V2',
  '/monitoring/performance': 'Desempeño Operación y Desperdicios',
  '/monitoring/last-shift': 'Desempeño Turno Anterior',
  '/monitoring/charging': 'Registro Tiempos de Carga',
  '/monitoring/transfer-b57-unloading': 'Traslado a Punto de Descarga',
  '/monitoring/discharging': 'Tiempo en Muro de Descarga',
  '/monitoring/transfer-b57': 'Tiempo Traslado a B57',
  '/monitoring/idle': 'Tiempo en Ralenti',
  '/monitoring/effective-time-driver': 'Conductores Operativos',
  '/monitoring/punctures': 'Pinchazos',
  '/monitoring/composting': 'Composteo Combustible',
  '/monitoring/roller': 'Pasadas de Rodillo',
  '/monitoring/can': 'Dashboard CAN Última Hora',
  '/monitoring/geofenceg1': 'Paso Geocerca G1',
  '/monitoring/lowvelocity': 'Velocidades Bajas',
  '/security/security-initial': 'Seguridad',
  '/security/truck-approach': 'Acercamiento entre camiones',
  '/security/velocity-violation': 'Transgresiones de Velocidad',
  '/security/brake-retarder': 'Frenos y Retardador',
  '/security/velocity-historic': 'Histórico de Velocidad',
  '/records/records-initial': 'Fichas',
  '/security/can': 'Dashboard CAN Histórico',
  '/security/fatigue': 'Fatiga y Somnolencia',
  '/security/sensors-count': 'Sensores Presión',
  '/security/train': 'Registro Cruce Tren',
  '/security/camera': 'Estado Cámara Fatiga',
  '/records/driver': 'Conductores',
  '/records/machines': 'Equipos',
  // '/records/geofences': 'Geocercas',
  '/records/routes': 'Rutas',
  '/records/gates': 'Pórtico',
  '/database/database-initial': 'Bases de Datos',
  '/database/gps': 'gps',
  '/database/canbus': 'CanBus',
  '/database/productivity': 'Cuadro Mando de Productividad',
  '/database/hourmeter': 'Horómetro',
  '/map': 'Mapa',
  '/fronts': 'Geocercas Frentes',
  '/users/users-initial': 'Usuarios',
  '/users/recomendations': 'Recomendaciones',
  '/orders/order': 'Orden',
  '/reports/report': 'Reporte',
  '/productivity/kpitree': 'kpitree',
  '/can/dashboard': 'Dashboard CAN',
  '/huella/dashboard': 'Huella',
  '/huella/ralenti': 'Ralenti',
  '/cycles/cycles': 'Ciclos',
  '/times/times': 'Disponibilidad y utilización',
};

// Viewer: has access to everything
// Security: has access to security module and map in monitoging
// Maintenance: has access to maintenance module and map in monitoring
export const permissionsMap = {
  viewer: [
    'MONITORING-INITIAL',
    'PRODUCTIVITY-INITIAL',
    'SECURITY-INITIAL',
    'MAINTENANCE-INITIAL',
    'RECORDS-INITIAL',
    'DATABASE-INITIAL',
    'USERS-INITIAL',
    'RECOMENDATIONS',
    'MAP',
    'MAPV2',
    'PERFORMANCE',
    'LAST-SHIFT',
    'CHARGING',
    'TRANSFER-B57-DISCHARGING',
    'DISCHARGING',
    'TRANSFER-B57',
    'IDLE',
    'EFFECTIVE-TIME-DRIVER',
    'PUNCTURES',
    'COMPOSTING',
    'ROLLER',
    'CAN',
    'HUELLA',
    'RALENTI',
    'FATIGUE',
    'HISTORIC',
    'DAILY',
    'WEEKLY',
    'MONTHLY',
    'ASARCO',
    'SPEED',
    'TRUCK-APPROACH',
    'VELOCITY-VIOLATION',
    'VELOCITY-HISTORIC',
    'PREVENTIVE',
    'PREDICTIVE',
    'ONGOING',
    'COMPLETED',
    'DRIVER',
    'MACHINES',
    'GEOFENCES',
    'ROUTES',
    'GPS',
    'CANBUS',
    'HOURMETER',
    'GEOFENCE-MAP',
    'GATES',
    'SENSORS-COUNT',
    'BRAKE-RETARDER',
    'TRAIN',
    'CAMERA',
    'PERMANENCE',
    'GEOFENCEG1',
    'BREAKFAST',
    'SPEEDGEOFENCE',
    'DAILYTURN',
    'LOWVELOCITY',
    'CYCLEWALLS',
    'METRICS',
    'PTO',
    'ORDER',
    'REPORT',
    'KPITREE',
    'DASHBOARD',
    'CYCLES',
    'TIMES',
  ],
  security: [
    'SECURITY-INITIAL',
    'MONITORING-INITIAL',
    'MAP',
    'TRUCK-APPROACH',
    'VELOCITY-VIOLATION',
    'VELOCITY-HISTORIC',
    'BRAKE-RETARDER',
    'FATIGUE',
  ],
  maintenance: [
    'MAINTENANCE-INITIAL',
    'MONITORING-INITIAL',
    'MAP',
    'ONGOING',
    'COMPLETED',
  ],
};
